import type { OrderStatus as OS } from '@/types/enums'

export interface KanbanColumnDef {
  id: string
  title: string
  statuses: OS[]
}

/** ТЗ §9.1 — колонки десктопного канбана */
export const KANBAN_COLUMNS: KanbanColumnDef[] = [
  { id: 'drafts', title: 'Черновики', statuses: ['DRAFT'] },
  { id: 'pool', title: 'Поиск', statuses: ['SEARCH'] },
  { id: 'assigned', title: 'Назначен', statuses: ['ASSIGNED'] },
  {
    id: 'work',
    title: 'В работе',
    statuses: ['DRIVING', 'ARRIVED', 'INSPECTION'],
  },
  { id: 'appraisal', title: 'Оценка', statuses: ['APPRAISAL'] },
  {
    id: 'buyout',
    title: 'Выкуп',
    statuses: ['BUYING', 'DOCUMENT_PREPARATION', 'PAYMENT_TRANSFER'],
  },
  {
    id: 'transport',
    title: 'Транспортировка',
    statuses: ['TRANSPORTATION'],
  },
  { id: 'done', title: 'Завершённые', statuses: ['COMPLETED'] },
]

export const ARCHIVE_STATUSES: OS[] = [
  'CANCELLED',
  'REFUSED_BY_INSPECTOR',
  'REFUSED_BY_SELLER',
  'REFUSED_BUYOUT',
]
